import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import BarChart from '../../../components/BarChart/BarChart';
import NoData from '../../../components/NoData/NoData';
import SectionTitle from '../../../components/SectionTitle/SectionTitle';
import { useStatistics } from '../../../hooks/useStatistics';

function WeddingDates() {
  const { t } = useTranslation();
  const [chartData, setChartData] = useState<any[]>([]);
  const [yearLabels, setYearLabels] = useState<string[]>([]);
  const data = useStatistics('total-month');

  useEffect(() => {
    if (Object.keys(data).length > 0) {
      const yearLabels = Object.keys(data["2021 Collection"]).sort();
      setYearLabels(yearLabels);
      const chartData = Object.entries(data).map(([label, values], index) => {
        const chartValues = yearLabels.map((month) => values?.[month] ?? 0);
        const backgroundColor = [`rgba(75, 192, 192, 0.${index + 2})`];
        return {
          label,
          data: chartValues,
          backgroundColor,
          borderColor: backgroundColor,
          borderWidth: 1,
        };
      });
      setChartData(chartData);
    }
  }, [data]);

  return (
    <>
      <SectionTitle text={t("stats.month_x_collection")} />
      {chartData.length > 0 ? (
        <BarChart title="Test" xLabels={yearLabels} dataSets={chartData} />
      ) : (
        <NoData message={t("global.empty_results")} />
      )}
    </>
  );
}

export default WeddingDates;
